"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.getEOTFlag=void 0;/* jshint esnext: true */ /**
 * Function checks and returns target value set in window
 * Returns with false if value not found in window
 * Caller should handle based on the requirements if value is false
 *
 * @param eotId checks for value in window obj.
 */var getEOTFlag=function(){var a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:"";a=a.split("_").pop();var b;// check if target set value available in window
return b=!!(window.analyticsSwy&&window.analyticsSwy.testFlags&&window.analyticsSwy.testFlags["EOT_"+a])&&window.analyticsSwy.testFlags["EOT_"+a],b};exports.getEOTFlag=getEOTFlag;